
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/80 backdrop-blur-md'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('inicio')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/e515f14a-a9fd-442b-99b0-c74c61c69843.png" 
              alt="Ortodoncia Especializada" 
              className="h-12 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('inicio')} className="text-petrol-700 hover:text-olive-500 transition-colors whitespace-nowrap cursor-pointer">
              Inicio
            </button>
            <button onClick={() => scrollToSection('tipos')} className="text-petrol-700 hover:text-olive-500 transition-colors whitespace-nowrap cursor-pointer">
              Tipos de Ortodoncia
            </button>
            <button onClick={() => scrollToSection('casos')} className="text-petrol-700 hover:text-olive-500 transition-colors whitespace-nowrap cursor-pointer">
              Casos Clínicos
            </button>
            <button onClick={() => scrollToSection('clinicas')} className="text-petrol-700 hover:text-olive-500 transition-colors whitespace-nowrap cursor-pointer">
              Clínicas
            </button>
            <button onClick={() => scrollToSection('doctores')} className="text-petrol-700 hover:text-olive-500 transition-colors whitespace-nowrap cursor-pointer">
              Doctores
            </button>
            <button onClick={() => scrollToSection('contacto')} className="text-petrol-700 hover:text-olive-500 transition-colors whitespace-nowrap cursor-pointer">
              Contacto
            </button>
          </div>

          <button 
            onClick={() => scrollToSection('contacto')}
            className="hidden md:flex items-center space-x-2 bg-olive-500 text-white px-6 py-2.5 rounded-full hover:bg-olive-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-line"></i>
            <span>Agendar Consulta</span>
          </button>

          <button className="md:hidden text-petrol-700 cursor-pointer">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
